/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var aa = require("react");

function k(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var ba = !1;

function m(a, b) {
  ba && (ba = !1, "<" !== b[0] && a.push("\x3c!-- --\x3e"));
  return "\x3c!-- --\x3e" === b ? ba = !0 : a.push(b);
}

var q = Object.prototype.hasOwnProperty,
    ca = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    da = {},
    ea = {};

function fa(a) {
  if (q.call(ea, a)) return !0;
  if (q.call(da, a)) return !1;
  if (ca.test(a)) return ea[a] = !0;
  da[a] = !0;
  return !1;
}

function r(a, b, c, d, f, e, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = f;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = e;
  this.removeEmptyString = g;
}

var t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  t[a] = new r(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  t[b] = new r(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  t[a] = new r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  t[a] = new r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  t[a] = new r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  t[a] = new r(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  t[a] = new r(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  t[a] = new r(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  t[a] = new r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ha = /[\-:]([a-z])/g;

function ia(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(ha, ia);
  t[b] = new r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(ha, ia);
  t[b] = new r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(ha, ia);
  t[b] = new r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  t[a] = new r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
t.xlinkHref = new r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  t[a] = new r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var u = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    ja = ["Webkit", "ms", "Moz", "O"];
Object.keys(u).forEach(function (a) {
  ja.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    u[b] = u[a];
  });
});
var ka = /["'&<>]/;

function v(a) {
  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
  a = "" + a;
  var b = ka.exec(a);

  if (b) {
    var c = "",
        d,
        f = 0;

    for (d = b.index; d < a.length; d++) {
      switch (a.charCodeAt(d)) {
        case 34:
          b = "&quot;";
          break;

        case 38:
          b = "&amp;";
          break;

        case 39:
          b = "&#x27;";
          break;

        case 60:
          b = "&lt;";
          break;

        case 62:
          b = "&gt;";
          break;

        default:
          continue;
      }

      f !== d && (c += a.substring(f, d));
      f = d + 1;
      c += b;
    }

    a = f !== d ? c + a.substring(f, d) : c;
  }

  return a;
}

var la = /([A-Z])/g,
    ma = /^ms-/,
    na = Array.isArray;

function w(a, b) {
  return {
    insertionMode: a,
    selectedValue: b
  };
}

function oa(a, b, c) {
  switch (b) {
    case "select":
      return w(1, null != c.value ? c.value : c.defaultValue);

    case "svg":
      return w(2, null);

    case "math":
      return w(3, null);

    case "foreignObject":
      return w(1, null);

    case "table":
      return w(4, null);

    case "thead":
    case "tbody":
    case "tfoot":
      return w(5, null);

    case "colgroup":
      return w(7, null);

    case "tr":
      return w(6, null);
  }

  return 4 <= a.insertionMode || 0 === a.insertionMode ? w(1, null) : a;
}

function pa(a, b) {
  "" !== b && a.push(v(b), "\x3c!-- --\x3e");
}

var qa = new Map();

function ra(a, b, c) {
  if ("object" !== _typeof(c)) throw Error(k(62));
  b = !0;

  for (var d in c) {
    if (q.call(c, d)) {
      var f = c[d];

      if (null != f && "boolean" !== typeof f && "" !== f) {
        if (0 === d.indexOf("--")) {
          var e = v(d);
          f = v(("" + f).trim());
        } else {
          e = d;
          var g = qa.get(e);
          void 0 !== g ? e = g : (g = v(e.replace(la, "-$1").toLowerCase().replace(ma, "-ms-")), qa.set(e, g), e = g);
          f = "number" === typeof f ? 0 === f || q.call(u, d) ? "" + f : f + "px" : v(("" + f).trim());
        }

        b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
      }
    }
  }

  b || a.push('"');
}

function y(a, b, c, d) {
  switch (c) {
    case "style":
      ra(a, b, d);
      return;

    case "defaultValue":
    case "defaultChecked":
    case "innerHTML":
    case "suppressContentEditableWarning":
    case "suppressHydrationWarning":
      return;
  }

  if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) if (b = t.hasOwnProperty(c) ? t[c] : null, null !== b) {
    switch (_typeof(d)) {
      case "function":
      case "symbol":
        return;

      case "boolean":
        if (!b.acceptsBooleans) return;
    }

    c = b.attributeName;

    switch (b.type) {
      case 3:
        d && a.push(" ", c, '=""');
        break;

      case 4:
        !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', v(d), '"');
        break;

      case 5:
        isNaN(d) || a.push(" ", c, '="', v(d), '"');
        break;

      case 6:
        !isNaN(d) && 1 <= d && a.push(" ", c, '="', v(d), '"');
        break;

      default:
        b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', v(d), '"');
    }
  } else if (fa(c)) {
    switch (_typeof(d)) {
      case "function":
      case "symbol":
        return;

      case "boolean":
        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
    }

    a.push(" ", c, '="', v(d), '"');
  }
}

function A(a, b, c) {
  if (null != b) {
    if (null != c) throw Error(k(60));
    if ("object" !== _typeof(b) || !("__html" in b)) throw Error(k(61));
    b = b.__html;
    null !== b && void 0 !== b && a.push("" + b);
  }
}

function sa(a) {
  var b = "";
  aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}

function ta(a, b, c, d) {
  a.push(B(c));
  var f = c = null,
      e;

  for (e in b) {
    if (q.call(b, e)) {
      var g = b[e];
      if (null != g) switch (e) {
        case "children":
          c = g;
          break;

        case "dangerouslySetInnerHTML":
          f = g;
          break;

        default:
          y(a, d, e, g);
      }
    }
  }

  a.push(">");
  A(a, f, c);
  return "string" === typeof c ? (a.push(v(c)), null) : c;
}

var ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
    va = new Map();

function B(a) {
  var b = va.get(a);

  if (void 0 === b) {
    if (!ua.test(a)) throw Error(k(65, a));
    b = "<" + a;
    va.set(a, b);
  }

  return b;
}

function wa(a, b, c, d, f) {
  switch (b) {
    case "select":
      a.push(B("select"));
      var e = null,
          g = null;

      for (n in c) {
        if (q.call(c, n)) {
          var h = c[n];
          if (null != h) switch (n) {
            case "children":
              e = h;
              break;

            case "dangerouslySetInnerHTML":
              g = h;
              break;

            case "defaultValue":
            case "value":
              break;

            default:
              y(a, d, n, h);
          }
        }
      }

      a.push(">");
      A(a, g, e);
      return e;

    case "option":
      g = f.selectedValue;
      a.push(B("option"));
      var l = h = null,
          p = null;
      var n = null;

      for (e in c) {
        if (q.call(c, e) && (b = c[e], null != b)) switch (e) {
          case "children":
            h = b;
            break;

          case "selected":
            p = b;
            break;

          case "dangerouslySetInnerHTML":
            n = b;
            break;

          case "value":
            l = b;

          default:
            y(a, d, e, b);
        }
      }

      if (null != g) {
        if (c = null !== l ? "" + l : sa(h), na(g)) for (d = 0; d < g.length; d++) {
          if ("" + g[d] === c) {
            a.push(' selected=""');
            break;
          }
        } else "" + g === c && a.push(' selected=""');
      } else p && a.push(' selected=""');
      a.push(">");
      A(a, n, h);
      return h;

    case "textarea":
      a.push(B("textarea"));
      n = g = e = null;

      for (h in c) {
        if (q.call(c, h) && (l = c[h], null != l)) switch (h) {
          case "children":
            n = l;
            break;

          case "value":
            e = l;
            break;

          case "defaultValue":
            g = l;
            break;

          case "dangerouslySetInnerHTML":
            throw Error(k(91));

          default:
            y(a, d, h, l);
        }
      }

      null === e && null !== g && (e = g);
      a.push(">");

      if (null != n) {
        if (null != e) throw Error(k(92));
        if (na(n) && 1 < n.length) throw Error(k(93));
        e = "" + n;
      }

      "string" === typeof e && "\n" === e[0] && a.push("\n");
      null !== e && a.push(v("" + e));
      return null;

    case "input":
      a.push(B("input"));
      l = n = h = e = null;

      for (g in c) {
        if (q.call(c, g) && (p = c[g], null != p)) switch (g) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(k(399, "input"));

          case "defaultChecked":
            l = p;
            break;

          case "defaultValue":
            h = p;
            break;

          case "checked":
            n = p;
            break;

          case "value":
            e = p;
            break;

          default:
            y(a, d, g, p);
        }
      }

      null !== n ? y(a, d, "checked", n) : null !== l && y(a, d, "checked", l);
      null !== e ? y(a, d, "value", e) : null !== h && y(a, d, "value", h);
      a.push("/>");
      return null;

    case "menuitem":
      a.push(B("menuitem"));

      for (var z in c) {
        if (q.call(c, z) && (e = c[z], null != e)) switch (z) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(k(400));

          default:
            y(a, d, z, e);
        }
      }

      a.push(">");
      return null;

    case "listing":
    case "pre":
      a.push(B(b));
      g = e = null;

      for (l in c) {
        if (q.call(c, l) && (h = c[l], null != h)) switch (l) {
          case "children":
            e = h;
            break;

          case "dangerouslySetInnerHTML":
            g = h;
            break;

          default:
            y(a, d, l, h);
        }
      }

      a.push(">");

      if (null != g) {
        if (null != e) throw Error(k(60));
        if ("object" !== _typeof(g) || !("__html" in g)) throw Error(k(61));
        c = g.__html;
        null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
      }

      "string" === typeof e && "\n" === e[0] && a.push("\n");
      return e;

    case "area":
    case "base":
    case "br":
    case "col":
    case "embed":
    case "hr":
    case "img":
    case "keygen":
    case "link":
    case "meta":
    case "param":
    case "source":
    case "track":
    case "wbr":
      a.push(B(b));

      for (var C in c) {
        if (q.call(c, C) && (e = c[C], null != e)) switch (C) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(k(399, b));

          default:
            y(a, d, C, e);
        }
      }

      a.push("/>");
      return null;

    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return ta(a, c, b, d);

    case "html":
      return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), ta(a, c, b, d);

    default:
      if (-1 === b.indexOf("-") && "string" !== typeof c.is) return ta(a, c, b, d);
      a.push(B(b));
      g = e = null;

      for (p in c) {
        if (q.call(c, p) && (h = c[p], null != h)) switch (p) {
          case "children":
            e = h;
            break;

          case "dangerouslySetInnerHTML":
            g = h;
            break;

          case "style":
            ra(a, d, h);
            break;

          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;

          default:
            fa(p) && "function" !== typeof h && "symbol" !== _typeof(h) && a.push(" ", p, '="', v(h), '"');
        }
      }

      a.push(">");
      A(a, g, e);
      return e;
  }
}

function xa(a, b, c) {
  m(a, '\x3c!--$?--\x3e<template id="');
  if (null === c) throw Error(k(395));
  m(a, c);
  return m(a, '"></template>');
}

function ya(a, b, c, d) {
  switch (c.insertionMode) {
    case 0:
    case 1:
      return m(a, '<div hidden id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 2:
      return m(a, '<svg aria-hidden="true" style="display:none" id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 3:
      return m(a, '<math aria-hidden="true" style="display:none" id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 4:
      return m(a, '<table hidden id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 5:
      return m(a, '<table hidden><tbody id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 6:
      return m(a, '<table hidden><tr id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    case 7:
      return m(a, '<table hidden><colgroup id="'), m(a, b.segmentPrefix), b = d.toString(16), m(a, b), m(a, '">');

    default:
      throw Error(k(397));
  }
}

function za(a, b) {
  switch (b.insertionMode) {
    case 0:
    case 1:
      return m(a, "</div>");

    case 2:
      return m(a, "</svg>");

    case 3:
      return m(a, "</math>");

    case 4:
      return m(a, "</table>");

    case 5:
      return m(a, "</tbody></table>");

    case 6:
      return m(a, "</tr></table>");

    case 7:
      return m(a, "</colgroup></table>");

    default:
      throw Error(k(397));
  }
}

function Aa(a, b) {
  b = void 0 === b ? "" : b;
  return {
    bootstrapChunks: [],
    startInlineScript: "<script>",
    placeholderPrefix: b + "P:",
    segmentPrefix: b + "S:",
    boundaryPrefix: b + "B:",
    idPrefix: b,
    nextSuspenseID: 0,
    sentCompleteSegmentFunction: !1,
    sentCompleteBoundaryFunction: !1,
    sentClientRenderFunction: !1,
    generateStaticMarkup: a
  };
}

var D = Object.assign,
    Ba = Symbol["for"]("react.element"),
    Ca = Symbol["for"]("react.portal"),
    Da = Symbol["for"]("react.fragment"),
    Ea = Symbol["for"]("react.strict_mode"),
    Fa = Symbol["for"]("react.profiler"),
    Ga = Symbol["for"]("react.provider"),
    Ha = Symbol["for"]("react.context"),
    Ia = Symbol["for"]("react.forward_ref"),
    Ja = Symbol["for"]("react.suspense"),
    Ka = Symbol["for"]("react.suspense_list"),
    La = Symbol["for"]("react.memo"),
    Ma = Symbol["for"]("react.lazy"),
    Na = Symbol["for"]("react.scope"),
    Oa = Symbol["for"]("react.debug_trace_mode"),
    Pa = Symbol["for"]("react.legacy_hidden"),
    Qa = Symbol["for"]("react.default_value"),
    Ra = Symbol.iterator;

function Sa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case Da:
      return "Fragment";

    case Ca:
      return "Portal";

    case Fa:
      return "Profiler";

    case Ea:
      return "StrictMode";

    case Ja:
      return "Suspense";

    case Ka:
      return "SuspenseList";
  }

  if ("object" === _typeof(a)) switch (a.$$typeof) {
    case Ha:
      return (a.displayName || "Context") + ".Consumer";

    case Ga:
      return (a._context.displayName || "Context") + ".Provider";

    case Ia:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;

    case La:
      return b = a.displayName || null, null !== b ? b : Sa(a.type) || "Memo";

    case Ma:
      b = a._payload;
      a = a._init;

      try {
        return Sa(a(b));
      } catch (c) {}

  }
  return null;
}

var Ta = {};

function Ua(a, b) {
  a = a.contextTypes;
  if (!a) return Ta;
  var c = {},
      d;

  for (d in a) {
    c[d] = b[d];
  }

  return c;
}

var E = null;

function F(a, b) {
  if (a !== b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    var c = b.parent;

    if (null === a) {
      if (null !== c) throw Error(k(401));
    } else {
      if (null === c) throw Error(k(401));
      F(a, c);
    }

    b.context._currentValue2 = b.value;
  }
}

function Va(a) {
  a.context._currentValue2 = a.parentValue;
  a = a.parent;
  null !== a && Va(a);
}

function Wa(a) {
  var b = a.parent;
  null !== b && Wa(b);
  a.context._currentValue2 = a.value;
}

function Xa(a, b) {
  a.context._currentValue2 = a.parentValue;
  a = a.parent;
  if (null === a) throw Error(k(402));
  a.depth === b.depth ? F(a, b) : Xa(a, b);
}

function Ya(a, b) {
  var c = b.parent;
  if (null === c) throw Error(k(402));
  a.depth === c.depth ? F(a, c) : Ya(a, c);
  b.context._currentValue2 = b.value;
}

function G(a) {
  var b = E;
  b !== a && (null === b ? Wa(a) : null === a ? Va(b) : b.depth === a.depth ? F(b, a) : b.depth > a.depth ? Xa(b, a) : Ya(b, a), E = a);
}

var Za = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueSetState: function enqueueSetState(a, b) {
    a = a._reactInternals;
    null !== a.queue && a.queue.push(b);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b) {
    a = a._reactInternals;
    a.replace = !0;
    a.queue = [b];
  },
  enqueueForceUpdate: function enqueueForceUpdate() {}
};

function $a(a, b, c, d) {
  var f = void 0 !== a.state ? a.state : null;
  a.updater = Za;
  a.props = c;
  a.state = f;
  var e = {
    queue: [],
    replace: !1
  };
  a._reactInternals = e;
  var g = b.contextType;
  a.context = "object" === _typeof(g) && null !== g ? g._currentValue2 : d;
  g = b.getDerivedStateFromProps;
  "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : D({}, f, g), a.state = f);
  if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && Za.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
    if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];else {
      e = g ? b[0] : a.state;
      f = !0;

      for (g = g ? 1 : 0; g < b.length; g++) {
        var h = b[g];
        h = "function" === typeof h ? h.call(a, e, c, d) : h;
        null != h && (f ? (f = !1, e = D({}, e, h)) : D(e, h));
      }

      a.state = e;
    }
  } else e.queue = null;
}

var ab = {
  id: 1,
  overflow: ""
};

function bb(a, b, c) {
  var d = a.id;
  a = a.overflow;
  var f = 32 - H(d) - 1;
  d &= ~(1 << f);
  c += 1;
  var e = 32 - H(b) + f;

  if (30 < e) {
    var g = f - f % 5;
    e = (d & (1 << g) - 1).toString(32);
    d >>= g;
    f -= g;
    return {
      id: 1 << 32 - H(b) + f | c << f | d,
      overflow: e + a
    };
  }

  return {
    id: 1 << e | c << f | d,
    overflow: a
  };
}

var H = Math.clz32 ? Math.clz32 : cb,
    db = Math.log,
    eb = Math.LN2;

function cb(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (db(a) / eb | 0) | 0;
}

function fb(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var gb = "function" === typeof Object.is ? Object.is : fb,
    I = null,
    hb = null,
    J = null,
    K = null,
    L = !1,
    M = !1,
    N = 0,
    O = null,
    P = 0;

function Q() {
  if (null === I) throw Error(k(321));
  return I;
}

function ib() {
  if (0 < P) throw Error(k(312));
  return {
    memoizedState: null,
    queue: null,
    next: null
  };
}

function jb() {
  null === K ? null === J ? (L = !1, J = K = ib()) : (L = !0, K = J) : null === K.next ? (L = !1, K = K.next = ib()) : (L = !0, K = K.next);
  return K;
}

function kb() {
  hb = I = null;
  M = !1;
  J = null;
  P = 0;
  K = O = null;
}

function lb(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function mb(a, b, c) {
  I = Q();
  K = jb();

  if (L) {
    var d = K.queue;
    b = d.dispatch;

    if (null !== O && (c = O.get(d), void 0 !== c)) {
      O["delete"](d);
      d = K.memoizedState;

      do {
        d = a(d, c.action), c = c.next;
      } while (null !== c);

      K.memoizedState = d;
      return [d, b];
    }

    return [K.memoizedState, b];
  }

  a = a === lb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
  K.memoizedState = a;
  a = K.queue = {
    last: null,
    dispatch: null
  };
  a = a.dispatch = nb.bind(null, I, a);
  return [K.memoizedState, a];
}

function ob(a, b) {
  I = Q();
  K = jb();
  b = void 0 === b ? null : b;

  if (null !== K) {
    var c = K.memoizedState;

    if (null !== c && null !== b) {
      var d = c[1];

      a: if (null === d) d = !1;else {
        for (var f = 0; f < d.length && f < b.length; f++) {
          if (!gb(b[f], d[f])) {
            d = !1;
            break a;
          }
        }

        d = !0;
      }

      if (d) return c[0];
    }
  }

  a = a();
  K.memoizedState = [a, b];
  return a;
}

function nb(a, b, c) {
  if (25 <= P) throw Error(k(301));
  if (a === I) if (M = !0, a = {
    action: c,
    next: null
  }, null === O && (O = new Map()), c = O.get(b), void 0 === c) O.set(b, a);else {
    for (b = c; null !== b.next;) {
      b = b.next;
    }

    b.next = a;
  }
}

function pb() {
  throw Error(k(394));
}

function R() {}

var qb = {
  readContext: function readContext(a) {
    return a._currentValue2;
  },
  useContext: function useContext(a) {
    Q();
    return a._currentValue2;
  },
  useMemo: ob,
  useReducer: mb,
  useRef: function useRef(a) {
    I = Q();
    K = jb();
    var b = K.memoizedState;
    return null === b ? (a = {
      current: a
    }, K.memoizedState = a) : b;
  },
  useState: function useState(a) {
    return mb(lb, a);
  },
  useInsertionEffect: R,
  useLayoutEffect: function useLayoutEffect() {},
  useCallback: function useCallback(a, b) {
    return ob(function () {
      return a;
    }, b);
  },
  useImperativeHandle: R,
  useEffect: R,
  useDebugValue: R,
  useDeferredValue: function useDeferredValue(a) {
    Q();
    return a;
  },
  useTransition: function useTransition() {
    Q();
    return [!1, pb];
  },
  useId: function useId() {
    var a = hb.treeContext;
    var b = a.overflow;
    a = a.id;
    a = (a & ~(1 << 32 - H(a) - 1)).toString(32) + b;
    var c = S;
    if (null === c) throw Error(k(404));
    b = N++;
    a = ":" + c.idPrefix + "R" + a;
    0 < b && (a += "H" + b.toString(32));
    return a + ":";
  },
  useMutableSource: function useMutableSource(a, b) {
    Q();
    return b(a._source);
  },
  useSyncExternalStore: function useSyncExternalStore(a, b, c) {
    if (void 0 === c) throw Error(k(407));
    return c();
  }
},
    S = null,
    rb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

function sb(a) {
  console.error(a);
}

function T() {}

function tb(a, b, c, d, f, e, g, h, l) {
  var p = [],
      n = new Set();
  b = {
    destination: null,
    responseState: b,
    progressiveChunkSize: void 0 === d ? 12800 : d,
    status: 0,
    fatalError: null,
    nextSegmentId: 0,
    allPendingTasks: 0,
    pendingRootTasks: 0,
    completedRootSegment: null,
    abortableTasks: n,
    pingedTasks: p,
    clientRenderedBoundaries: [],
    completedBoundaries: [],
    partialBoundaries: [],
    onError: void 0 === f ? sb : f,
    onAllReady: void 0 === e ? T : e,
    onShellReady: void 0 === g ? T : g,
    onShellError: void 0 === h ? T : h,
    onFatalError: void 0 === l ? T : l
  };
  c = U(b, 0, null, c);
  c.parentFlushed = !0;
  a = ub(b, a, null, c, n, Ta, null, ab);
  p.push(a);
  return b;
}

function ub(a, b, c, d, f, e, g, h) {
  a.allPendingTasks++;
  null === c ? a.pendingRootTasks++ : c.pendingTasks++;
  var l = {
    node: b,
    ping: function ping() {
      var b = a.pingedTasks;
      b.push(l);
      1 === b.length && vb(a);
    },
    blockedBoundary: c,
    blockedSegment: d,
    abortSet: f,
    legacyContext: e,
    context: g,
    treeContext: h
  };
  f.add(l);
  return l;
}

function U(a, b, c, d) {
  return {
    status: 0,
    id: -1,
    index: b,
    parentFlushed: !1,
    chunks: [],
    children: [],
    formatContext: d,
    boundary: c
  };
}

function V(a, b) {
  a = a.onError;
  a(b);
}

function W(a, b) {
  var c = a.onShellError;
  c(b);
  c = a.onFatalError;
  c(b);
  null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}

function wb(a, b, c, d, f) {
  I = {};
  hb = b;
  N = 0;

  for (a = c(d, f); M;) {
    M = !1, N = 0, P += 1, K = null, a = c(d, f);
  }

  kb();
  return a;
}

function xb(a, b, c, d) {
  var f = c.render(),
      e = d.childContextTypes;

  if (null !== e && void 0 !== e) {
    var g = b.legacyContext;
    if ("function" !== typeof c.getChildContext) d = g;else {
      c = c.getChildContext();

      for (var h in c) {
        if (!(h in e)) throw Error(k(108, Sa(d) || "Unknown", h));
      }

      d = D({}, g, c);
    }
    b.legacyContext = d;
    X(a, b, f);
    b.legacyContext = g;
  } else X(a, b, f);
}

function yb(a, b) {
  if (a && a.defaultProps) {
    b = D({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

function zb(a, b, c, d, f) {
  if ("function" === typeof c) {
    if (c.prototype && c.prototype.isReactComponent) {
      f = Ua(c, b.legacyContext);
      var e = c.contextType;
      e = new c(d, "object" === _typeof(e) && null !== e ? e._currentValue2 : f);
      $a(e, c, d, f);
      xb(a, b, e, c);
    } else {
      e = Ua(c, b.legacyContext);
      f = wb(a, b, c, d, e);
      var g = 0 !== N;
      if ("object" === _typeof(f) && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $a(f, c, d, e), xb(a, b, f, c);else if (g) {
        d = b.treeContext;
        b.treeContext = bb(d, 1, 0);

        try {
          X(a, b, f);
        } finally {
          b.treeContext = d;
        }
      } else X(a, b, f);
    }
  } else if ("string" === typeof c) switch (f = b.blockedSegment, e = wa(f.chunks, c, d, a.responseState, f.formatContext), g = f.formatContext, f.formatContext = oa(g, c, d), Ab(a, b, e), f.formatContext = g, c) {
    case "area":
    case "base":
    case "br":
    case "col":
    case "embed":
    case "hr":
    case "img":
    case "input":
    case "keygen":
    case "link":
    case "meta":
    case "param":
    case "source":
    case "track":
    case "wbr":
      break;

    default:
      f.chunks.push("</", c, ">");
  } else {
    switch (c) {
      case Pa:
      case Oa:
      case Ea:
      case Fa:
      case Da:
        X(a, b, d.children);
        return;

      case Ka:
        X(a, b, d.children);
        return;

      case Na:
        throw Error(k(343));

      case Ja:
        a: {
          c = b.blockedBoundary;
          f = b.blockedSegment;
          e = d.fallback;
          d = d.children;
          g = new Set();
          var h = {
            id: null,
            rootSegmentID: -1,
            parentFlushed: !1,
            pendingTasks: 0,
            forceClientRender: !1,
            completedSegments: [],
            byteSize: 0,
            fallbackAbortableTasks: g
          },
              l = U(a, f.chunks.length, h, f.formatContext);
          f.children.push(l);
          var p = U(a, 0, null, f.formatContext);
          p.parentFlushed = !0;
          b.blockedBoundary = h;
          b.blockedSegment = p;

          try {
            if (Ab(a, b, d), p.status = 1, Y(h, p), 0 === h.pendingTasks) break a;
          } catch (n) {
            p.status = 4, V(a, n), h.forceClientRender = !0;
          } finally {
            b.blockedBoundary = c, b.blockedSegment = f;
          }

          b = ub(a, e, c, l, g, b.legacyContext, b.context, b.treeContext);
          a.pingedTasks.push(b);
        }

        return;
    }

    if ("object" === _typeof(c) && null !== c) switch (c.$$typeof) {
      case Ia:
        d = wb(a, b, c.render, d, f);

        if (0 !== N) {
          c = b.treeContext;
          b.treeContext = bb(c, 1, 0);

          try {
            X(a, b, d);
          } finally {
            b.treeContext = c;
          }
        } else X(a, b, d);

        return;

      case La:
        c = c.type;
        d = yb(c, d);
        zb(a, b, c, d, f);
        return;

      case Ga:
        f = d.children;
        c = c._context;
        d = d.value;
        e = c._currentValue2;
        c._currentValue2 = d;
        g = E;
        E = d = {
          parent: g,
          depth: null === g ? 0 : g.depth + 1,
          context: c,
          parentValue: e,
          value: d
        };
        b.context = d;
        X(a, b, f);
        a = E;
        if (null === a) throw Error(k(403));
        d = a.parentValue;
        a.context._currentValue2 = d === Qa ? a.context._defaultValue : d;
        a = E = a.parent;
        b.context = a;
        return;

      case Ha:
        d = d.children;
        d = d(c._currentValue2);
        X(a, b, d);
        return;

      case Ma:
        f = c._init;
        c = f(c._payload);
        d = yb(c, d);
        zb(a, b, c, d, void 0);
        return;
    }
    throw Error(k(130, null == c ? c : _typeof(c), ""));
  }
}

function X(a, b, c) {
  b.node = c;

  if ("object" === _typeof(c) && null !== c) {
    switch (c.$$typeof) {
      case Ba:
        zb(a, b, c.type, c.props, c.ref);
        return;

      case Ca:
        throw Error(k(257));

      case Ma:
        var d = c._init;
        c = d(c._payload);
        X(a, b, c);
        return;
    }

    if (na(c)) {
      Bb(a, b, c);
      return;
    }

    null === c || "object" !== _typeof(c) ? d = null : (d = Ra && c[Ra] || c["@@iterator"], d = "function" === typeof d ? d : null);

    if (d && (d = d.call(c))) {
      c = d.next();

      if (!c.done) {
        var f = [];

        do {
          f.push(c.value), c = d.next();
        } while (!c.done);

        Bb(a, b, f);
      }

      return;
    }

    a = Object.prototype.toString.call(c);
    throw Error(k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
  }

  "string" === typeof c ? (b = b.blockedSegment.chunks, a.responseState.generateStaticMarkup ? b.push(v(c)) : pa(b, c)) : "number" === typeof c && (b = b.blockedSegment.chunks, c = "" + c, a.responseState.generateStaticMarkup ? b.push(v(c)) : pa(b, c));
}

function Bb(a, b, c) {
  for (var d = c.length, f = 0; f < d; f++) {
    var e = b.treeContext;
    b.treeContext = bb(e, d, f);

    try {
      Ab(a, b, c[f]);
    } finally {
      b.treeContext = e;
    }
  }
}

function Ab(a, b, c) {
  var d = b.blockedSegment.formatContext,
      f = b.legacyContext,
      e = b.context;

  try {
    return X(a, b, c);
  } catch (l) {
    if (kb(), "object" === _typeof(l) && null !== l && "function" === typeof l.then) {
      c = l;
      var g = b.blockedSegment,
          h = U(a, g.chunks.length, null, g.formatContext);
      g.children.push(h);
      a = ub(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
      c.then(a, a);
      b.blockedSegment.formatContext = d;
      b.legacyContext = f;
      b.context = e;
      G(e);
    } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, G(e), l;
  }
}

function Cb(a) {
  var b = a.blockedBoundary;
  a = a.blockedSegment;
  a.status = 3;
  Db(this, b, a);
}

function Eb(a) {
  var b = a.blockedBoundary;
  a.blockedSegment.status = 3;
  null === b ? (this.allPendingTasks--, 2 !== this.status && (this.status = 2, null !== this.destination && this.destination.push(null))) : (b.pendingTasks--, b.forceClientRender || (b.forceClientRender = !0, b.parentFlushed && this.clientRenderedBoundaries.push(b)), b.fallbackAbortableTasks.forEach(Eb, this), b.fallbackAbortableTasks.clear(), this.allPendingTasks--, 0 === this.allPendingTasks && (a = this.onAllReady, a()));
}

function Y(a, b) {
  if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
    var c = b.children[0];
    c.id = b.id;
    c.parentFlushed = !0;
    1 === c.status && Y(a, c);
  } else a.completedSegments.push(b);
}

function Db(a, b, c) {
  if (null === b) {
    if (c.parentFlushed) {
      if (null !== a.completedRootSegment) throw Error(k(389));
      a.completedRootSegment = c;
    }

    a.pendingRootTasks--;
    0 === a.pendingRootTasks && (a.onShellError = T, b = a.onShellReady, b());
  } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(Cb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));

  a.allPendingTasks--;
  0 === a.allPendingTasks && (a = a.onAllReady, a());
}

function vb(a) {
  if (2 !== a.status) {
    var b = E,
        c = rb.current;
    rb.current = qb;
    var d = S;
    S = a.responseState;

    try {
      var f = a.pingedTasks,
          e;

      for (e = 0; e < f.length; e++) {
        var g = f[e];
        var h = a,
            l = g.blockedSegment;

        if (0 === l.status) {
          G(g.context);

          try {
            X(h, g, g.node), g.abortSet["delete"](g), l.status = 1, Db(h, g.blockedBoundary, l);
          } catch (x) {
            if (kb(), "object" === _typeof(x) && null !== x && "function" === typeof x.then) {
              var p = g.ping;
              x.then(p, p);
            } else {
              g.abortSet["delete"](g);
              l.status = 4;
              var n = g.blockedBoundary,
                  z = x;
              V(h, z);
              null === n ? W(h, z) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
              h.allPendingTasks--;

              if (0 === h.allPendingTasks) {
                var C = h.onAllReady;
                C();
              }
            }
          } finally {}
        }
      }

      f.splice(0, e);
      null !== a.destination && Fb(a, a.destination);
    } catch (x) {
      V(a, x), W(a, x);
    } finally {
      S = d, rb.current = c, c === qb && G(b);
    }
  }
}

function Z(a, b, c) {
  c.parentFlushed = !0;

  switch (c.status) {
    case 0:
      var d = c.id = a.nextSegmentId++;
      a = a.responseState;
      m(b, '<template id="');
      m(b, a.placeholderPrefix);
      a = d.toString(16);
      m(b, a);
      return m(b, '"></template>');

    case 1:
      c.status = 2;
      var f = !0;
      d = c.chunks;
      var e = 0;
      c = c.children;

      for (var g = 0; g < c.length; g++) {
        for (f = c[g]; e < f.index; e++) {
          m(b, d[e]);
        }

        f = Gb(a, b, f);
      }

      for (; e < d.length - 1; e++) {
        m(b, d[e]);
      }

      e < d.length && (f = m(b, d[e]));
      return f;

    default:
      throw Error(k(390));
  }
}

function Gb(a, b, c) {
  var d = c.boundary;
  if (null === d) return Z(a, b, c);
  d.parentFlushed = !0;
  if (d.forceClientRender) return a.responseState.generateStaticMarkup || m(b, "\x3c!--$!--\x3e"), Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : m(b, "\x3c!--/$--\x3e"), a;

  if (0 < d.pendingTasks) {
    d.rootSegmentID = a.nextSegmentId++;
    0 < d.completedSegments.length && a.partialBoundaries.push(d);
    var f = a.responseState;
    var e = f.nextSuspenseID++;
    f = f.boundaryPrefix + e.toString(16);
    d = d.id = f;
    xa(b, a.responseState, d);
    Z(a, b, c);
    return m(b, "\x3c!--/$--\x3e");
  }

  if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), xa(b, a.responseState, d.id), Z(a, b, c), m(b, "\x3c!--/$--\x3e");
  a.responseState.generateStaticMarkup || m(b, "\x3c!--$--\x3e");
  c = d.completedSegments;
  if (1 !== c.length) throw Error(k(391));
  Gb(a, b, c[0]);
  a = a.responseState.generateStaticMarkup ? !0 : m(b, "\x3c!--/$--\x3e");
  return a;
}

function Hb(a, b, c) {
  ya(b, a.responseState, c.formatContext, c.id);
  Gb(a, b, c);
  return za(b, c.formatContext);
}

function Ib(a, b, c) {
  for (var d = c.completedSegments, f = 0; f < d.length; f++) {
    Jb(a, b, c, d[f]);
  }

  d.length = 0;
  a = a.responseState;
  d = c.id;
  c = c.rootSegmentID;
  m(b, a.startInlineScript);
  a.sentCompleteBoundaryFunction ? m(b, '$RC("') : (a.sentCompleteBoundaryFunction = !0, m(b, 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
  if (null === d) throw Error(k(395));
  c = c.toString(16);
  m(b, d);
  m(b, '","');
  m(b, a.segmentPrefix);
  m(b, c);
  return m(b, '")\x3c/script>');
}

function Jb(a, b, c, d) {
  if (2 === d.status) return !0;
  var f = d.id;

  if (-1 === f) {
    if (-1 === (d.id = c.rootSegmentID)) throw Error(k(392));
    return Hb(a, b, d);
  }

  Hb(a, b, d);
  a = a.responseState;
  m(b, a.startInlineScript);
  a.sentCompleteSegmentFunction ? m(b, '$RS("') : (a.sentCompleteSegmentFunction = !0, m(b, 'function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
  m(b, a.segmentPrefix);
  f = f.toString(16);
  m(b, f);
  m(b, '","');
  m(b, a.placeholderPrefix);
  m(b, f);
  return m(b, '")\x3c/script>');
}

function Fb(a, b) {
  try {
    var c = a.completedRootSegment;

    if (null !== c && 0 === a.pendingRootTasks) {
      Gb(a, b, c);
      a.completedRootSegment = null;
      var d = a.responseState.bootstrapChunks;

      for (c = 0; c < d.length - 1; c++) {
        m(b, d[c]);
      }

      c < d.length && m(b, d[c]);
    }

    var f = a.clientRenderedBoundaries,
        e;

    for (e = 0; e < f.length; e++) {
      d = b;
      var g = a.responseState,
          h = f[e].id;
      m(d, g.startInlineScript);
      g.sentClientRenderFunction ? m(d, '$RX("') : (g.sentClientRenderFunction = !0, m(d, 'function $RX(a){if(a=document.getElementById(a))a=a.previousSibling,a.data="$!",a._reactRetry&&a._reactRetry()};$RX("'));
      if (null === h) throw Error(k(395));
      m(d, h);

      if (!m(d, '")\x3c/script>')) {
        a.destination = null;
        e++;
        f.splice(0, e);
        return;
      }
    }

    f.splice(0, e);
    var l = a.completedBoundaries;

    for (e = 0; e < l.length; e++) {
      if (!Ib(a, b, l[e])) {
        a.destination = null;
        e++;
        l.splice(0, e);
        return;
      }
    }

    l.splice(0, e);
    var p = a.partialBoundaries;

    for (e = 0; e < p.length; e++) {
      var n = p[e];

      a: {
        f = a;
        g = b;
        var z = n.completedSegments;

        for (h = 0; h < z.length; h++) {
          if (!Jb(f, g, n, z[h])) {
            h++;
            z.splice(0, h);
            var C = !1;
            break a;
          }
        }

        z.splice(0, h);
        C = !0;
      }

      if (!C) {
        a.destination = null;
        e++;
        p.splice(0, e);
        return;
      }
    }

    p.splice(0, e);
    var x = a.completedBoundaries;

    for (e = 0; e < x.length; e++) {
      if (!Ib(a, b, x[e])) {
        a.destination = null;
        e++;
        x.splice(0, e);
        return;
      }
    }

    x.splice(0, e);
  } finally {
    0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
  }
}

function Kb(a) {
  try {
    var b = a.abortableTasks;
    b.forEach(Eb, a);
    b.clear();
    null !== a.destination && Fb(a, a.destination);
  } catch (c) {
    V(a, c), W(a, c);
  }
}

function Lb() {}

function Mb(a, b, c) {
  var d = !1,
      f = null,
      e = "",
      g = {
    push: function push(a) {
      null !== a && (e += a);
      return !0;
    },
    destroy: function destroy(a) {
      d = !0;
      f = a;
    }
  },
      h = !1;
  a = tb(a, Aa(c, b ? b.identifierPrefix : void 0), {
    insertionMode: 1,
    selectedValue: null
  }, Infinity, Lb, void 0, function () {
    h = !0;
  }, void 0, void 0);
  vb(a);
  Kb(a);
  if (1 === a.status) a.status = 2, g.destroy(a.fatalError);else if (2 !== a.status && null === a.destination) {
    a.destination = g;

    try {
      Fb(a, g);
    } catch (l) {
      V(a, l), W(a, l);
    }
  }
  if (d) throw f;
  if (!h) throw Error(k(426));
  return e;
}

exports.renderToNodeStream = function () {
  throw Error(k(207));
};

exports.renderToStaticMarkup = function (a, b) {
  return Mb(a, b, !0);
};

exports.renderToStaticNodeStream = function () {
  throw Error(k(208));
};

exports.renderToString = function (a, b) {
  return Mb(a, b, !1);
};

exports.version = "18.1.0";